import React, { useState } from 'react';
import {
  Col, Form, Row, Spinner,
} from 'react-bootstrap';
import useCompanySelect from 'utils/hooks/useCompanySelect';
import AlertsCollection from 'components/AlertsCollection';
import Selector from 'components/DesignSystem/Selector';
import Button from 'components/DesignSystem/Button';
import ContractFormFields from '../FormFields';
import useSaveContract from './useSaveContract';

export default function ContractsForm() {
  const [selectorValue, setSelectorValue] = useState('');
  const { companyOptions, companiesLoading } = useCompanySelect();
  const {
    isLoading: isContractSaveLoading, validated, requestSuccess, contractSaveHook, alerts,
  } = useSaveContract();

  if (companiesLoading) {
    return <Spinner />;
  }

  if (requestSuccess) {
    return <>Contrato salvo com sucesso</>;
  }

  return (
    <Form
      onSubmit={contractSaveHook}
      validated={validated}
      noValidate
    >
      <fieldset disabled={isContractSaveLoading}>
        <Row>
          <Col>
            <AlertsCollection alerts={alerts} />
          </Col>
        </Row>
        <Selector
          id="company-selector"
          label="Empresa"
          error="Uma empresa deve ser selecionada"
          value={selectorValue}
          setValue={setSelectorValue}
          validated={validated}
          isValid={!!selectorValue}
          search
          searchPlaceholder="Buscar empresa"
        >
          {companyOptions?.map((companyOption) => (
            <option key={companyOption.value} value={`${companyOption.value}`}>
              {companyOption.label}
            </option>
          ))}
        </Selector>
        <input type="hidden" name="contract-company" value={selectorValue} />
        <ContractFormFields contractId={0} />
        <Row className="mt-3">
          <Col>
            <Button
              className="mt-3 float-end"
              submit
              disabled={isContractSaveLoading}
            >
              Salvar
              {isContractSaveLoading && <Spinner size="sm" className="ms-2" />}
            </Button>
          </Col>
        </Row>
      </fieldset>
    </Form>
  );
}
